import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { ResponseDto } from '../../../shared/dtos/response.dto';

@Injectable({
    providedIn: 'root'
})
export class ResendUcmService {
    public constructor(private http: HttpClient) { }

    public resend(pac: string): Observable<ResponseDto> {
        return this.http.post<ResponseDto>(environment.outgoingRequestAPI + `Contract/${pac}/resend`, {});
    }
}
